/* eslint-disable no-console, no-case-declarations, no-unused-vars */
import { graphqlClient } from "@/utils/http";
import * as request from "@/data/graphql/master-data.graphql.js";

export async function getAllMasterData() {
  getAllFilters();
  getFaculties();
  getDepartments();
  getPrefixes();
  getAssessments();
  getSubjectGroups();
  getSubjects();
}

export async function getAllFilters() {
  getDegrees();
  getProjects();
  getCurriculums();
}

export const getDegrees = createServiceFunction("degrees", () => request.getDegrees());

/* export async function getDegrees() {
  const data = await graphqlClient(request.getDegrees());
  return data;
} */

export const getProjects = createServiceFunction("projects", () => request.getProjects());

/* export async function getProjects() {
  const data = await graphqlClient(request.getProjects());
  return data;
} */

export const getFaculties = createServiceFunction("faculties", () => request.getFaculties());

/* export async function getFaculties() {
  const data = await graphqlClient(request.getFaculties());
  return data;
} */

export const getDepartments = createServiceFunction("departments", () => request.getDepartments());

/* export async function getDepartments() {
  const data = await graphqlClient(request.getDepartments());
  return data;
} */

export const getPrefixes = createServiceFunction("prefixed", () => request.getPrefixes());

/* export async function getPrefixes() {
  const data = await graphqlClient(request.getPrefixes());
  return data;
} */

export const getCurriculums = createServiceFunction("curriculums", () => request.getCurriculums());

/* export async function getCurriculums() {
  const data = await graphqlClient(request.getCurriculums());
  return data;
} */

export const getAssessments = createServiceFunction("assesments", () => request.getAssessments());

/* export async function getAssessments() {
  const data = await graphqlClient(request.getAssessments());
  return data;
} */

export const getSubjectGroups = createServiceFunction("subjectGroups", () => request.getSubjectGroups());

/* export async function getSubjectGroups() {
  const data = await graphqlClient(request.getSubjectGroups());
  return data;
} */

export const getSubjects = createServiceFunction("subjects", () => request.getSubjects());

export const getSubjectsBySubjectGroup = async (subjectGroupId) => { 
  const query = request.getSubjectsBySubjectGroup(subjectGroupId);
  return await graphqlClient(query);
};

/* export async function getSubjects() {
  const data = await graphqlClient(request.getSubjects());
  return data;
} */

function createServiceFunction(key, fn) {
  return async function () {
    const localData = JSON.parse(localStorage.getItem('cd'));
    let data = checkDataOnLocalStorage(localData, key);
    if (!data) {
      data = await graphqlClient(fn());
      storeNewDataOnLocalStorage(localData, data, key);
    }
    return data; 
  }
}

function checkDataOnLocalStorage(data, key) {
  if (data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      /* // TODO: Implement cache key checker
      if (data.key.cacheKey === checkCacheKey(key)) {
        
      }
      */
      return data[key];
    }
  }
  return null;
}

function storeNewDataOnLocalStorage(localData, data, key) {
  if (localData, data && key) {
    const newData = JSON.stringify({ ...localData, [key]: data });
    localStorage.setItem('cd', newData);
  }
}

function checkCacheKey(key) {
  // TODO: Create cache key checking
}
